module.exports = __webpack_public_path__ + "static/media/kids_51.8296c6be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_51.jpg
// module id = 5907
// module chunks = 0